import { memo } from "react"
import { Box, Typography } from "@mui/material"
import { styles } from "./BadgeHeader.styles"

const BadgeHeader = memo(
  ({
    badgeText,
    badgeColor,
    title,
    titleColor,
    subtitle,
    endElement,
    showDivider = false,
    dividerColor,
    reserveDivider = false,
    sx,
  }) => {
    return (
      <Box sx={[styles.container, sx]}>
        <Box sx={styles.headerRow}>
          {badgeText && <Box sx={styles.badge(badgeColor)}>{badgeText}</Box>}
          <Box sx={styles.textContainer}>
            <Typography variant="body2Bold" sx={styles.title(titleColor)}>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body" sx={styles.subtitle}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {endElement && <Box>{endElement}</Box>}
        </Box>
        {(showDivider || reserveDivider) && (
          <Box
            sx={styles.divider(
              showDivider ? dividerColor || badgeColor : "transparent"
            )}
          />
        )}
      </Box>
    )
  }
)

export default BadgeHeader
